import { useCallback, useEffect, useState } from 'react';

import { useDeps } from 'src/hooks/useEpicDeps';

type YotpoWidgetsContainer = {
    initWidgets: (initializeWidgets?: boolean) => void;
};

export type UseYotpotScriptReturn = {
    /**
     * Reload Yotpo widgets
     *
     * Call this function to reload a Yotpo widget or to initialize it
     * after the Yotpo script has been loaded.
     */
    reloadWidgets: () => void;
};

export function useYotpoScript() {
    const { YOTPO_ENABLED } = useDeps().env;

    const [yotpoWidgetsContainer, setYotpoWidgetsContainer] = useState<YotpoWidgetsContainer | undefined>();

    const reloadWidgets: UseYotpotScriptReturn['reloadWidgets'] = useCallback(() => {
        yotpoWidgetsContainer?.initWidgets();
    }, [yotpoWidgetsContainer]);

    useEffect(() => {
        if (YOTPO_ENABLED && window && window?.['yotpoWidgetsContainer']) {
            setYotpoWidgetsContainer(window?.['yotpoWidgetsContainer'] as YotpoWidgetsContainer);
        }

        return () => {
            setYotpoWidgetsContainer(undefined);
        };
    }, [YOTPO_ENABLED]);

    return {
        reloadWidgets,
    };
}

export default useYotpoScript;
